/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import {
  Flex,
  Heading,
  Button,
  FormControl,
  Checkbox,
  FormLabel,
} from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import FormInput from "../../../components/forms/form-Input";
import { replenishmentModelsDefault } from "../constants";
import { useLookupCurrencyMultiples } from "../../../services/lookups-mutations";

export default function ReplenishmentModels({
  onPrevStep,
  onNextStep,
  currencies,
  models,
  addData,
  disabled,
  toggleStandardModels,
  followStandardModels,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const [currentEditingDeno, setCurrentEditingDeno] = useState(null);
  const {
    mutate: getMultiples,
    data: multipleList,

    reset: resetMultiple,
  } = useLookupCurrencyMultiples();

  const {
    handleSubmit,
    control,
    getValues,
    clearErrors,
    reset,
    formState: { errors },
    trigger,
    watch,
    setValue,
  } = useForm({
    defaultValues: { ...replenishmentModelsDefault, models: [...models] },
  });
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    code: { required: "Please Enter Code" },
    currency: { required: "Please Select Currency" },
    multiple: { required: "Please Select Multiple" },
    noOfCassettes: {
      required: "Please Enter Cassettes",
      validate: (value) => {
        if (!value || value === "0") return "Please Enter Cassettes";
        return true;
      },
    },
    noOfNotes: {
      required: "Please Enter Notes",
      validate: (value) => {
        if (!value || value === "0") return "Please Enter Notes";
        return true;
      },
    },
  };
  const { fields: denominationFields, remove: denominationRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "denominations",
    });
  const {
    fields: modelFields,
    remove: modelRemove,
    update: modelUpdate,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "models",
  });
  useEffect(() => {
    if (addData) addData([...modelFields]);
  }, [modelFields]);

  useEffect(() => {
    resetMultiple();
    const _currency = watch("currency");
    if (_currency && _currency.shortName) {
      getMultiples(_currency.shortName);
    }
  }, [watch("currency")]);
  const submitInfo = async () => {
    const _data = { ...getValues() };
    const isCodeValid = await trigger("code");
    if (!isCodeValid) return;

    const _fields = [...modelFields];
    const modelObj = {
      code: _data.code,
      denominations: _data.denominations,
      expanded: false,
    };

    if (currentEditing !== null) {
      _fields[currentEditing] = { ...modelObj };
      setCurrentEditing(null);
    } else {
      _fields.push({ ...modelObj });
    }
    reset({ ...replenishmentModelsDefault, models: _fields });
  };

  const cancelEditing = () => {
    setCurrentEditing(null);
    const _fields = [...modelFields];
    reset({ ...replenishmentModelsDefault, models: _fields });
  };

  const addDenomination = async () => {
    const _denominations = [...denominationFields];
    const newItem = {
      currency: getValues("currency"),
      multiple: getValues("multiple"),
      noOfCassettes: getValues("noOfCassettes"),
      noOfNotes: getValues("noOfNotes"),
    };

    if (currentEditingDeno === null) {
      _denominations.push(newItem);
    } else {
      _denominations[currentEditingDeno] = newItem;
      setCurrentEditingDeno(null);
    }
    const _models = [...modelFields];
    reset({
      ...replenishmentModelsDefault,
      code: getValues("code"),
      denominations: _denominations,
      models: _models,
    });
    if (errors.denominations) {
      clearErrors("denominations");
    }
  };

  const onCurrencyChange = () => {
    setValue("multiple", "");
  };

  const editDenominationCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit"
          cursor="pointer"
          onClick={() => {
            const _models = [...modelFields];
            const _denominations = [...denominationFields];
            reset({
              code: getValues("code"),
              ...dataItem,
              models: _models,
              denominations: _denominations,
            });
            setCurrentEditingDeno(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteDenominationCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete "
          cursor="pointer"
          onClick={() => {
            denominationRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const editModelCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit"
          cursor="pointer"
          onClick={() => {
            reset({ ...dataItem, models: [...modelFields] });
            setCurrentEditing(dataIndex);
            setCurrentEditingDeno(null);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteModelCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete"
          cursor="pointer"
          onClick={() => {
            modelRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const expandChange = ({ dataIndex }) => {
    const _models = [...modelFields];
    _models[dataIndex].expanded = !_models[dataIndex].expanded;
    modelUpdate(dataIndex, _models[dataIndex]);
  };

  function DetailComponent({ dataItem }) {
    return (
      <>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Denominations
        </Heading>
        <Grid data={dataItem.denominations}>
          <GridColumn
            title="Currency"
            cell={({ dataItem }) => (
              <td>
                {dataItem.currency.shortName}&nbsp;{dataItem.multiple.text}
              </td>
            )}
          />
          <GridColumn title="Cassettes" field="noOfCassettes" />
          <GridColumn title="Notes" field="noOfNotes" />
        </Grid>
      </>
    );
  }
  const cancelDenominationEditing = () => {
    reset({ ...getValues(), ...replenishmentModelsDefault });
    setCurrentEditingDeno(null);
  };
  return (
    <form onSubmit={handleSubmit(addDenomination)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Flex direction="column">
          <FormControl>
            <Checkbox
              isChecked={followStandardModels}
              onChange={() => {
                if (!followStandardModels) {
                  reset({ replenishmentModelsDefault, models: [] });
                }

                toggleStandardModels();
              }}
            >
              <FormLabel style={{ margin: 0, whiteSpace: "nowrap" }}>
                Follow Standard Models For Customer
              </FormLabel>
            </Checkbox>
          </FormControl>
          {disabled ? (
            <p
              className="error-message"
              style={{ width: "100%", color: "black", whiteSpace: "nowrap" }}
            >
              Can Not Edit When Following Standard Models
            </p>
          ) : (
            <></>
          )}
        </Flex>

        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex
            w="100%"
            justify="flex-end"
            flexDirection="row"
            gap="16px"
            onClick={() => {}}
          >
            <Button type="button" onClick={() => onPrevStep(modelFields)}>
              Back
            </Button>
            <Button type="button" onClick={() => onNextStep(modelFields)}>
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Code"
        rules={formValidationRules.code}
        name="code"
        disabled={disabled}
      />

      <Heading
        style={{
          width: "100%",
          fontSize: "14px",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      >
        Denominations
      </Heading>

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Currency"
        name="currency"
        id="shortName"
        text="name"
        data={currencies || []}
        placeholder="Select Currency"
        rules={formValidationRules.currency}
        onChange={onCurrencyChange}
        dropdownProps={{ filterable: true }}
        disabled={disabled}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Multiples"
        name="multiple"
        id="id"
        text="text"
        data={
          multipleList?.data.map((elm) => ({
            id: elm.multiple,
            text: elm.multiple,
          })) || []
        }
        placeholder="Select Multiple"
        rules={formValidationRules.multiple}
        dropdownProps={{ filterable: true }}
        disabled={disabled || !watch("currency")}
      />

      <NumericInput
        {...generalFieldProps}
        isRequired
        label="Cassettes"
        rules={formValidationRules.noOfCassettes}
        name="noOfCassettes"
        disabled={disabled}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        label="Notes"
        rules={formValidationRules.noOfNotes}
        name="noOfNotes"
        disabled={disabled}
      />

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditingDeno !== null ? (
          <Button onClick={cancelDenominationEditing} disabled={disabled}>
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button type="submit" disabled={disabled}>
          {currentEditingDeno !== null
            ? "Update Denomination"
            : "Add Denomination"}
        </Button>
      </div>

      <Grid data={denominationFields}>
        <GridColumn
          title="Currency"
          cell={({ dataItem }) => (
            <td>
              {dataItem.currency.shortName}&nbsp;{dataItem.multiple.text}
            </td>
          )}
        />
        <GridColumn title="Cassettes" field="noOfCassettes" />
        <GridColumn title="Notes" field="noOfNotes" />
        <GridColumn title="Edit" width={100} cell={editDenominationCell} />
        <GridColumn title="Delete" width={100} cell={deleteDenominationCell} />
      </Grid>
      <div
        style={{
          width: "100%",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: "4px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", gap: "16px" }}>
          {currentEditing !== null ? (
            <Button
              onClick={cancelEditing}
              style={{ width: "fit-content" }}
              disabled={disabled || denominationFields.length === 0}
            >
              Cancel
            </Button>
          ) : (
            <></>
          )}
          <Button
            onClick={submitInfo}
            style={{ width: "flex-end" }}
            disabled={disabled || denominationFields.length === 0}
          >
            {currentEditing !== null ? "Update Model" : "Add Model"}
          </Button>
        </div>

        {denominationFields.length === 0 ? (
          <p
            className="error-message"
            style={{ color: "black", textAlign: "right" }}
          >
            Please Add At least One Denomination To Enable
          </p>
        ) : (
          <></>
        )}
      </div>
      <Grid
        data={modelFields}
        detail={DetailComponent}
        expandField="expanded"
        onExpandChange={expandChange}
      >
        <GridColumn title="Code" field="code" />
        <GridColumn title="Edit" width={100} cell={editModelCell} />
        <GridColumn title="Delete" width={100} cell={deleteModelCell} />
      </Grid>
    </form>
  );
}
